// extracted by mini-css-extract-plugin
export default {"tableCell":"TableCell_tableCell__f0Wm8"};